export default __webpack_public_path__ + "f91cb2e0f0aeaf70b740d562c476f6f5.svg";